
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/change-password-required",
      function () {
        return require("private-next-pages/change-password-required.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/change-password-required"])
      });
    }
  